/*
  rosetta public variable name
*/

export const rosettaPublicName = 'rosettaData'

/**
 * rosetta custom event
 */
export const locationChangeEventName = 'rosetta-locationchange'

/*
  breakpoints
  as Bootstrap
*/

export const breakpoints = {
  // X-Small devices (portrait phones, less than 576px)
  xs: 0,
  // Small devices (landscape phones, 576px and up)
  sm: 576,
  // Medium devices (tablets, 768px and up)
  md: 768,
  // Large devices (desktops, 992px and up)
  lg: 992,
  // X-Large devices (large desktops, 1200px and up)
  xl: 1200,
  // XX-Large devices (larger desktops, 1400px and up)
  '2xl': 1400
}

/*
  data attribute
*/

export const dataAttribute = {
  recommenderId: 'data-rosetta-recommender-id',
  componentId: 'data-rosetta-component-id',
  engineId: 'data-rosetta-engine-id',
  queryId: 'data-rosetta-query-id',
  itemId: 'data-rosetta-item-id',
  currency: 'data-rosetta-currency',
  value: 'data-rosetta-value',
  provider: 'data-rosetta-provider',
  context: 'data-rosetta-context',
  source: 'data-rosetta-source',
  action: 'data-rosetta-action',
  pageType: 'data-rosetta-page-type',
  layout: 'data-rosetta-layout',
  pathname: 'data-rosetta-pathname'
}

/*
  Regex
*/

export const singleQuotePlaceholder = 'rosetta_single_quote_placeholder'

export const carouselLayoutRegex = /carousel|Carousel/
export const gridLayoutRegex = /Grid/
export const couponLayoutRegex = /coupon/
export const bannerLayoutRegex = /banner/
export const adLayoutRegex = /ad/
export const campaignLayoutRegex = /coupon|banner/
export const hesitateLayoutRegex = /Modal|Notification|Side/
export const scrollTriggerLayoutRegex = /scrollTrigger/
export const storyInPageRecommenderLayoutRegex = /^storyRecommender$/

/*
  storage keys
*/

// ids
export const GAClientIdKey = 'rosetta_ga_client_id'
export const fingerprintKey = 'rosetta_fingerprint-v2'
export const clientIdKey = 'rosetta_client_id'

// records
export const behaviorKey = 'rosetta_history'
export const behaviorsKey = 'rosetta_behaviors'
export const recordedOrdersKey = 'rosetta_recorded_orders'
export const copiedCouponsKey = 'rosetta_copied_coupons'
export const interactedBannersKey = 'rosetta_interacted_banners'

// attempts
export const attemptSelectKey = 'rosetta_attempt_select'
export const attemptUnselectKey = 'rosetta_attempt_unselect'
export const attemptCheckoutKey = 'rosetta_attempt_checkout'

// components
export const recommenderClass = 'rosetta-recommender'

export const containerTriggerTimesKey = container =>
  `rosetta_${container}_times`
export const storyReadedStateKey = 'rosetta_story_readed'

export const STORAGE_KEY__COMPONENT_STATUS = 'rosetta-component-status'
export const STORAGE_KEY__ATTEMPT_CLICKS = 'rosetta-attempt-clicks'

/**
 * URLSearchParams
 */
export const URL_SEARCH__AD_ID = 'rosetta-ad'
export const URL_SEARCH__AD_ITEM = 'rosetta-ad-item'

/*
  custom keys
*/

// waca
export const productMappingKey = 'rosetta_product_mapping'

// data

export const MutationObserver =
  // @ts-ignore
  window.MutationObserver || window.WebKitMutationObserver

export const viewedProductsKey = 'rosetta_viewed_products'

export const abTestKey = 'rosetta_exp'

// type AdMerchants = {
//   [appId: string]: {
//     id: number
//     appId: string
//     platform: string
//     url: string
//     page: 'checkout' | 'order'
//   }
// }
export const AD_MERCHANTS = {
  a_GdNDm1Ez1zEMsONPr33rmpgr: {
    id: 203,
    appId: 'a_GdNDm1Ez1zEMsONPr33rmpgr',
    platform: '91app',
    url: 'https://www.blueway-jeans.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Xdm9P6l0kEmkFBaonQnA6ad8: {
    id: 1429,
    appId: 'a_Xdm9P6l0kEmkFBaonQnA6ad8',
    platform: '91app',
    url: 'https://www.vans.com.tw/',
    page: 'order'
  },
  a_Vda2GN3QnVQwiyr6zK19j5JN: {
    id: 1488,
    appId: 'a_Vda2GN3QnVQwiyr6zK19j5JN',
    platform: 'meepshop',
    url: 'https://www.florettie.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_XdmqM4xz1ZDxTB0lOozk7Ad8: {
    id: 1498,
    appId: 'a_XdmqM4xz1ZDxTB0lOozk7Ad8',
    platform: 'shopline',
    url: 'https://www.anstw.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_qJOkP8Rrp3WyiK052B4DBOJV: {
    id: 250,
    appId: 'a_qJOkP8Rrp3WyiK052B4DBOJV',
    platform: 'cyberbiz',
    url: 'https://www.aishitoto.com.tw/zh-TW/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_mJK3wNnblG98sznE33zzKxJk: {
    id: 190,
    appId: 'a_mJK3wNnblG98sznE33zzKxJk',
    platform: 'shopline',
    url: 'https://www.art64.co',
    page: 'order',
    layout: 'animation-flip'
  },
  a_5d9155b6er9eCQ8P1NMwOBdD: {
    id: 1522,
    appId: 'a_5d9155b6er9eCQ8P1NMwOBdD',
    platform: 'shopline',
    url: 'https://www.qtr-best.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_XdmAZ1lpNZ6PuqEK7LlKMQd8: {
    id: 1524,
    appId: 'a_XdmAZ1lpNZ6PuqEK7LlKMQd8',
    platform: 'shopline',
    url: 'https://www.emstudio.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Rdlkn52aym7xHab0zrEjn2va: {
    id: 1527,
    appId: 'a_Rdlkn52aym7xHab0zrEjn2va',
    platform: 'shopline',
    url: 'https://www.fungoody.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_YJpX3DOxmkEWte74l9b0DEJQ: {
    id: 1540,
    appId: 'a_YJpX3DOxmkEWte74l9b0DEJQ',
    platform: 'cyberbiz',
    url: 'https://www.hutonggou.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_qJOqz72DlXAACKnj2zO825vV: {
    id: 1539,
    appId: 'a_qJOqz72DlXAACKnj2zO825vV',
    platform: 'cyberbiz',
    url: 'https://www.naturalskin.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_RdAQ5Eo67XkNTmYYqP1DPOdq: {
    id: 1548,
    appId: 'a_RdAQ5Eo67XkNTmYYqP1DPOdq',
    platform: 'cyberbiz',
    url: 'https://www.goodday0422.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Wdz0AwW155k2I7meGmVYXkgx: {
    id: 1542,
    appId: 'a_Wdz0AwW155k2I7meGmVYXkgx',
    platform: 'waca',
    url: 'https://www.jztee.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_zJ5Pn0LpxnzVc5M5wb5YzldX: {
    id: 1568,
    appId: 'a_zJ5Pn0LpxnzVc5M5wb5YzldX',
    platform: 'shopline',
    url: 'https://www.lisastaste.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_VdaVRzk680NyCMyLm4Vbo8JN: {
    id: 1549,
    appId: 'a_VdaVRzk680NyCMyLm4Vbo8JN',
    platform: 'easystore',
    url: 'https://www.perfect-time-jct.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_8dewqq6jXQLXuN1D2Wb2nzgl: {
    id: 1566,
    appId: 'a_8dewqq6jXQLXuN1D2Wb2nzgl',
    platform: 'cyberbiz',
    url: 'https://www.hioo.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Ggr2p8j4bL5PC3kD7obY3Bgp: {
    id: 98,
    appId: 'a_Ggr2p8j4bL5PC3kD7obY3Bgp',
    platform: 'shopline',
    url: 'https://www.j-well.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_nvB2aBo2njNDUBakn1jZM0vM: {
    id: 189,
    appId: 'a_nvB2aBo2njNDUBakn1jZM0vM',
    platform: 'shopline',
    url: 'https://www.funselect.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Ev77rAXNPjY5u39kWBmxeovZ: {
    id: 1590,
    appId: 'a_Ev77rAXNPjY5u39kWBmxeovZ',
    platform: 'shopline',
    url: 'https://www.obhl.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Ggrx5WRkK6pkTMekxXYzMzdp: {
    id: 110,
    appId: 'a_Ggrx5WRkK6pkTMekxXYzMzdp',
    platform: '91app',
    url: 'https://www.ahuaruok.com',
    page: 'order',
    layout: 'animation-flip'
  },
  a_PgW62NLG31bmHDLwD1NLD8JB: {
    id: 1599,
    appId: 'a_PgW62NLG31bmHDLwD1NLD8JB',
    platform: 'shopline',
    url: 'https://www.essentia.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_RJQQezLQRp9Wiq86Gw2oZZJl: {
    id: 186,
    appId: 'a_RJQQezLQRp9Wiq86Gw2oZZJl',
    platform: 'shopline',
    url: 'https://www.wowhoo.com.tw/',
    page: 'order'
  },
  a_kgDB21l764WziW8YK8y9aMdo: {
    id: 335,
    appId: 'a_kgDB21l764WziW8YK8y9aMdo',
    platform: '91app',
    url: 'https://www.softlighttw.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Ev7bGez5E87xfzZw5XQPxagZ: {
    id: 1192,
    appId: 'a_Ev7bGez5E87xfzZw5XQPxagZ',
    platform: '91app',
    url: 'https://www.eekoreanice.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Ggr5EZWZayy7H54nMbX5xDJp: {
    id: 295,
    appId: 'a_Ggr5EZWZayy7H54nMbX5xDJp',
    platform: 'shopline',
    url: 'https://www.bigsize.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_ovwXm4Ql8bBRSY4o1OA92qdK: {
    id: 1603,
    appId: 'a_ovwXm4Ql8bBRSY4o1OA92qdK',
    platform: '91app',
    url: 'https://concerto.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_5gyXyelwOkNwh9YEa4G88MJr: {
    id: 518,
    appId: 'a_5gyXyelwOkNwh9YEa4G88MJr',
    platform: 'shopline',
    url: 'https://www.nude4underwear.com/',
    page: 'order'
  },
  a_kvj2GOZzqoqVuXzZxllP4GvG: {
    id: 1608,
    appId: 'a_kvj2GOZzqoqVuXzZxllP4GvG',
    platform: 'shopline',
    url: 'https://www.colantotte.com.tw/',
    page: 'order'
  },
  a_RJQQbNl7YXKKSPW3p2e4q4Jl: {
    id: 1383,
    appId: 'a_RJQQbNl7YXKKSPW3p2e4q4Jl',
    platform: '91app',
    url: 'https://www.amhomeshop.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_GdNByrX29ReOILVaWwRDMldr: {
    id: 1606,
    appId: 'a_GdNByrX29ReOILVaWwRDMldr',
    platform: 'cyberbiz',
    url: 'https://shopping.ego-dpn.com/zh-TW/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_WdzVMyyk5yXQSo7bWpZq0bdx: {
    id: 284,
    appId: 'a_WdzVMyyk5yXQSo7bWpZq0bdx',
    platform: 'shopline',
    url: 'https://www.nu9.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_RdlMX8YzOy4niyVMxl7R8KJa: {
    id: 1615,
    appId: 'a_RdlMX8YzOy4niyVMxl7R8KJa',
    platform: 'cyberbiz',
    url: 'https://jeshop.cyberbiz.co/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_4gYRA9e4kb4RF42xR6602Gvl: {
    id: 1497,
    appId: 'a_4gYRA9e4kb4RF42xR6602Gvl',
    platform: '91app',
    url: 'https://www.johnhenry.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_Rdl87YzDY0yETaeOeVbO66da: {
    id: 1626,
    appId: 'a_Rdl87YzDY0yETaeOeVbO66da',
    platform: 'cyberbiz',
    url: 'https://www.curecare.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_XdmXD4jbV1O6fB8xwyWQLAv8: {
    id: 732,
    appId: 'a_XdmXD4jbV1O6fB8xwyWQLAv8',
    platform: 'easystore',
    url: 'https://www.nonishops.com/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_WdzXne9O42ePhAYRRynkmZgx: {
    id: 1632,
    appId: 'a_WdzXne9O42ePhAYRRynkmZgx',
    platform: 'cyberbiz',
    url: 'https://www.miss-fashion.store/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_mJKPmeBk7oOjhROl2Qk8Begk: {
    id: 1633,
    appId: 'a_mJKPmeBk7oOjhROl2Qk8Begk',
    platform: 'shopline',
    url: 'https://www.henis-shop.com.tw/',
    page: 'order',
    layout: 'animation-flip'
  },
  a_qJOqy1V8Bw9XCKGOV2Mo17vV: {
    id: 1647,
    appId: 'a_qJOqy1V8Bw9XCKGOV2Mo17vV',
    platform: 'shopline',
    url: 'https://www.ststudiodesigntw.com/',
    page: 'order',
    layout: 'animation-flip'
  }
}
